<template>
  <b-row no-gutters class="vams-summary">
    <div class="mr-4">
      <label class="col-head">Parts Order ID:</label>
      <h4>{{ partsOrder.partsOrderId }}</h4>
    </div>
    <div class="mr-4">
      <label class="col-head">Customer:</label>
      <h4>{{ partsOrder.customerName }}</h4>
    </div>
    <div class="mr-4">
      <label class="col-head">Customer Id:</label>
      <div>
        <h4>{{ partsOrder.customerId }}</h4>
      </div>
    </div>
    <div class="mr-4">
      <label class="col-head">FC Status:</label>
      <h4>{{ frontCounterStatus(partsOrder.posted) }}</h4>
    </div>
    <div class="mr-4">
      <label class="col-head">Total:</label>
      <h4>{{ (partsOrder.subTotal + partsOrder.amtTax) | currency }}</h4>
    </div>
    <div v-show="partsOrder.employeeId !== '999'" class="mr-4">
      <label class="col-head">Sales Person:</label>
      <h4>{{ partsOrder.employeeId }} -- {{ partsOrder.employeeName }}</h4>
    </div>
    <div v-if="partsOrder.originatedFrom" class="mr-4">
      <label class="col-head">Originated From:</label>
      <h4>{{ partsOrder.originatedFrom }}</h4>
    </div>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { PartsOrderGetters } from '@/shared/store/parts-order/types';

export default {
  name: 'PartsOrderSummary',
  computed: {
    ...mapGetters({
      partsOrder: PartsOrderGetters.GET_PARTS_ORDER
    })
  },
  methods: {
    frontCounterStatus(value) {
      if (value == 0) return 'Open';
      else if (value == 1) return 'Invoiced';
    }
  }
};
</script>
